import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { adminRewardsApi, AdminRewardListParams } from '@api/endpoints/adminRewards'

export function useAdminRewards(params: AdminRewardListParams) {
  return useQuery({
    queryKey: ['marketing', 'rewards', params],
    queryFn: () => adminRewardsApi.list(params),
    staleTime: 1000 * 60 * 2,
    placeholderData: keepPreviousData,
  })
}
